import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { McGlobalsServiceConfig } from '@medrio/common';
import { TranslateService } from '@ngx-translate/core';
import {
  ApiUrlService, AuthorizationTokenService, Context, ContextInitializerService, ContextService,
} from 'projects/cross-study-portal-lib/src/public-api';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoginUrlService } from './login-url.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationInitializerService {
  constructor(
    private translate: TranslateService,
    private authorizationToken: AuthorizationTokenService,
    private context: ContextService,
    private loginUrl: LoginUrlService,
    private apiUrlService: ApiUrlService,
    private globals: McGlobalsServiceConfig,
    private title: Title,
  ) { }

  init(contextService: ContextInitializerService<Context>) {
    const initialized = new BehaviorSubject<boolean>(false);

    contextService.getContext$().subscribe(context => {
      if (contextService.isInitialized) {
        console.error('failed to initialize application services. context must be initialized');
        initialized.next(false);
        initialized.complete();
      } else {
        this.context.instance = context;
        this.loginUrl.loginUrl = context.loginUrl;
        this.setGlobalServiceConfig(context);
        this.authorizationToken.set(context.accessToken);
        this.configureTranslateService(context).subscribe(
          {
            error: () => {
              console.warn('unable to load resource file for', context.userLanguage);
              initialized.next(true);
              initialized.complete();
            },
            complete: () => {
              initialized.next(true);
              initialized.complete();
            },
          });

        this.setPageTitle().subscribe();
      }

      return initialized;
    });

    return initialized.toPromise();
  }

  private setGlobalServiceConfig(context: Context) {
    this.globals.apiUrl = this.apiUrlService.get();
    this.globals.urls.apiUrl = this.apiUrlService.get();
    this.globals.logoutUrl = context.logoutUrl;
    this.globals.user = {
      userName: context.username,
    };
  }

  private configureTranslateService(context: Context) {
    const userLang = context.userLanguage?.substring(0, 2) ?? 'en';
    this.translate.setDefaultLang(userLang);
    return this.translate.use(userLang);
  }

  private setPageTitle() {
    return this.translate.get('webPageTitle').pipe(tap(webPageTitle => {
      this.title.setTitle(webPageTitle);
    }));
  }
}
